import {
  ButtonGroup,
  type ButtonGroupProps,
} from '@progress/kendo-react-buttons'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledButtonGroup.css'

export type StyledButtonGroupProps = ButtonGroupProps & {
  children?: React.ReactElement | React.ReactElement[]
  'data-testid'?: string
}

export const StyledButtonGroup = ({
  className,
  'data-testid': dataTestId = 'components-elements-styled-button-group',
  ...rest
}: StyledButtonGroupProps) => (
  <ButtonGroup
    className={classNames(styles.root, className)}
    data-testid={dataTestId}
    {...rest}
  />
)
